'use strict';exports.__esModule = true;var messageViews = {
  empty: 'empty',
  newMessage: 'newMessage',
  editMessage: 'editMessage',
  messages: 'messages' };exports.default =


messageViews;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/MessageFromCompany/contants.js
// module id = 2815
// module chunks = 0